import React, { useEffect } from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { USER_DATA_KEY } from '../../../constantes/LocalStorageEnum';
import { useFormInitialValues } from '../../../hooks/useFormInitialValues';

const Contact: React.FC = () => {
  const theme = ApiLocalStorage.get('theme') || {};
  const helpBoxConfig = theme?.login?.helpBox;
  const needHelp = !!helpBoxConfig;
  
  const userData = ApiLocalStorage.get(USER_DATA_KEY);
  const initialValues = useFormInitialValues('contact', userData);
  
  
  return (
    <>
      <DynamicForm
        pageName="contact"
        initialValues={initialValues}
      >
      {
        needHelp ? (
          <HelpBox
            title={helpBoxConfig?.title}
            description={helpBoxConfig?.description}
            linkText={helpBoxConfig?.linkText}
            linkUrl={helpBoxConfig?.linkUrl}
          />
        ) : undefined
      }
      </DynamicForm>
    </>
  );
};

export default Contact;
